import { render, staticRenderFns } from "./college-savings-journey.vue?vue&type=template&id=56fccc3e&lang=pug&"
import script from "./college-savings-journey.vue?vue&type=script&lang=js&"
export * from "./college-savings-journey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports